import { capitalize } from './helpers';

export function renderPath() {}
